import {PIXI} from '@colonist/pixi'
import {UIGameManager} from './UIGameManager'
import {GameStateEnums} from '../../../../shared/GameEnums'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables'
import {UIGameMechanic} from './UIGameEventController'
import {ClientUserState} from '../ClientUserState'

export class UIGameResponsiveController implements UIGameMechanic {
    protected readonly uiGameManager: UIGameManager
    static _resolutionScale: number = 1
    private forceHideAds: boolean = false

    constructor(uiGameManager: UIGameManager) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)
    }

    onEvent(data: any, eventType: GameStateEnums.UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.BeginnerModeStart: this.onBeginnerModeStart(); break
            default: break
        }
    }

    buildRenderer() {
        const size = this.getAppWnH()
        this.uiGameManager.canvasController.app.renderer.resize(size.w, size.h)
        this.uiGameManager.canvasController.app.view.style.top = '50%'
        this.uiGameManager.canvasController.app.view.style.transform = 'translate(0%, -50%)'
    }

    resizeScreen() {
        this.showVerticalAds() ? this.uiGameManager.adController?.showInGameAds() : this.uiGameManager.adController?.hideInGameAds()
        this.resizeCanvas()
    }

    private resizeCanvas() {
        const size = this.getAppWnH()
        this.uiGameManager.canvasController.app.renderer.resize(size.w, size.h)
        this.uiGameManager.canvasController.app.view.style.left = this.getCanvasX() + 'px'
        this.uiGameManager.canvasController.setCanvasConfigVariables()
        this.uiGameManager.eventController.sendEvent(undefined, UIGameEventEnums.CanvasResized)
    }

    getCanvasY(): number {
        const view = this.uiGameManager.canvasController.app.view
        return view.offsetTop - view.clientHeight / 2
    }

    getCanvasX(): number {
        const adWidth = this.showVerticalAds() ? UIGameResponsiveController.getInGameVerticalAdWidth() : 0
        const extraSpace = window.innerWidth - this.getAppWnH().w - adWidth * 2
        return adWidth + extraSpace / 2
    }

    protected showVerticalAds(): boolean {
        if(this.forceHideAds) return false
        if(ClientUserState.userState?.items.hideAds()) return false
        if(UIUtilsEjsVariables.isUserOnDiscord) return false
        if(PIXI.utils.isMobile.phone) return false
        if(UIUtilsEjsVariables.isUserOnMobileApp) return false
        if(document.fullscreenElement) return false
        if(window.innerWidth > 1500) return true
        if(window.innerWidth < window.innerHeight) return false
        return true
    }

    protected showHorizontalAds(): boolean {
        if(ClientUserState.userState?.items.hideAds()) return false
        if(UIUtilsEjsVariables.isUserOnDiscord) return false
        if(document.fullscreenElement) return false
        if(window.innerHeight < 1000) return false
        if(this.forceHideAds) return false
        return true
    }

    protected getAppWnH(): {w: number, h: number} {
        const maxRatio = 15 / 11
        let w = this.showVerticalAds() ? window.innerWidth - UIGameResponsiveController.getInGameVerticalAdWidth() * 2 : window.innerWidth
        let h = this.showHorizontalAds() ? window.innerHeight - UIGameResponsiveController.getInGameHorizontalAdHeight() : window.innerHeight
        if(UIGameResponsiveController.isDeviceHorizontalAndHaveHomeIndicator()) h -= 15
        if(UIGameResponsiveController.isDeviceMobileAndroid()) w -= 60

        if(w / h >= maxRatio) return {w: w, h: h}
        return {w: w, h: w / maxRatio}
    }

    private onBeginnerModeStart() {
        if(UIUtilsEjsVariables.isUserOnMobileApp && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI) return
        this.forceHideAds = true
        this.resizeScreen()
    }

    private static getInGameVerticalAdWidth(): number {
        const verticalAdWidth = 160
        const margin = 5
        const mobileZoom = 0.6
        // if(uiManager.resonsiveController.isHorizontalMobile()) return verticalAdWidth * mobileZoom
        return verticalAdWidth + margin
    }

    canShowBottomAd(): boolean {
        const bottomAdPadding = 5
        const heightLeftForBottomAd = (window.innerHeight - this.getAppWnH().h) / 2 - (bottomAdPadding * 1.5)
        return heightLeftForBottomAd >= UIGameResponsiveController.getInGameHorizontalAdHeight()
    }

    private static getInGameHorizontalAdHeight(): number {
        return 90
    }

    // private getInGameHorizontalAdWidth(): number {
    //     return 728
    // }

    private static isDeviceHorizontalAndHaveHomeIndicator(): boolean { // Home indicator is the bar at the bottom of iphones
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        const iPhone = /iPhone/.test(navigator.userAgent) && !(window as any).MSStream
        const aspect = window.screen.width / window.screen.height
        if(iPhone && aspect.toFixed(3) === '0.462') return true
        return false
    }

    private static isDeviceMobileAndroid(): boolean {
        if(!UIUtilsEjsVariables.isUserOnMobileApp) return false
        return /Android/i.test(navigator.userAgent)
    }

    // TODO: once the game is vertical, this should not be used
    static get resolutionScale(): number {
        return UIUtilsEjsVariables.isUserOnMobileApp ? 2 : 1
    }

    static set resolutionScale(value: number) {
        UIGameResponsiveController._resolutionScale = value
    }

    // eslint-disable-next-line class-methods-use-this
    getScaleForRotation(): number {
        if(UIUtilsEjsVariables.isUserOnMobileApp) {
            return window.innerWidth / this.uiGameManager.canvasController.appW
        }
        return 1
    }
}
